import "./LocationUserDetailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import {Field, FieldProps, Formik, FormikProps} from "formik";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Grid from "@mui/material/Grid";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import FeedbackComponent from "../../../../shared/components/feedback/feedbackComponent";
import AccordionComponent from "../../../../shared/components/accordion/accordionComponent";
import * as Yup from "yup";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import UserDetailsComponent from "../../../../shared/components/user-details/UserDetailsComponent";
import RouteConfigService from "../../../../shared/services/route-config.service";
import {useLocation, useNavigate} from "react-router-dom";
import LinkComponent from "../../../../shared/components/link/LinkComponent";

interface LocationUserDetailsAddComponentProps {
    locationId: number;
    next: Function;
    cancel: Function;
    prev: Function;
    locationDetails: any;
}

const locationUserDetailsValidationSchema = Yup.object({
    userId: Yup.string()
        .nullable(),
});


interface locationUserDetailsFormSchema {
    userId: string;
}

const locationUserInformationInitialValues: locationUserDetailsFormSchema = {
    userId: "",
}

const LocationUserDetailsAddComponent = (props: LocationUserDetailsAddComponentProps) => {
    const {next, locationId, cancel, prev, locationDetails} = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [userList, setUserList] = useState<any>([]);
    const [userListDropdown, setUserListDropdown] = useState<any>([]);
    const formikRef = useRef<FormikProps<any>>(null);

    const onHandleNext = useCallback(() => {
        next(userList);
    }, [next, userList]);

    const getUserListDropdown = useCallback(() => {
        CommonService._location.getLocationUserDetails().then((response) => {
            setUserListDropdown(response.data);
        }).catch((error) => {
            console.error("Unable to get location user", error)
        })
    }, [])

    const handleAddUser = useCallback((userId: string | number, locationId: string | number) => {
        const payload = {
            locationId: locationId,
            userId: userId
        }
        formikRef?.current?.setSubmitting(true);
        CommonService._location.addLocationUserDetails(payload).then((response) => {
            const selectedUser = userListDropdown.find((user: any) => user?.id?.toString() === userId?.toString());
            if (selectedUser) {
                setUserList((prev: any) => {
                    return [...prev, selectedUser]
                })
                if (formikRef) {
                    formikRef?.current?.setFieldValue("userId", "");
                    formikRef?.current?.setSubmitting(false);
                }
            }
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while adding user")
        })
    }, [userListDropdown])

    const handleRemoveUser = useCallback((user: any) => {
        const payload = {
            locationId: locationId,
            userId: user?.id
        }
        CommonService._location.removeLocationAssignedUser(payload).then((response) => {
            const userId = user?.id;
            setUserList((prev: any) => {
                return prev.filter((user: any) => user?.id?.toString() !== userId?.toString());
            })
            getUserListDropdown();
            CommonService._alert.showToast(response.message || "Removed user successfully", "success")
        }).catch((error) => {
            CommonService._alert.showToast(error.message || "Error while removing user", "error")
        })
    }, [getUserListDropdown, locationId])

    const handleRedirectUserModule = useCallback(() => {
        navigate(RouteConfigService.AddUserRoute() + CommonService.setUrlSearchParams({
            returnUrl: location.pathname + location.search,
            permissionType: "locationUser",
        }))
    }, [location.pathname, location.search, navigate])

    useEffect(() => {
        setUserList(locationDetails?.userDetails || []);
    }, [locationDetails]);

    useEffect(() => {
        getUserListDropdown();
    }, [getUserListDropdown]);

    return (
        <div className={'location-user-details-add-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'User Details'}
                handleClick={prev}
                tooltipData={"These details relate to the persons adding for this location."}
            />
            <div className="t-form t-form-back-navigation">
                <div className={'no-form'}>
                    <div className="t-form-controls-wrapper">
                        <>
                            <Formik
                                validationSchema={locationUserDetailsValidationSchema}
                                initialValues={locationUserInformationInitialValues}
                                validateOnChange={false}
                                validateOnBlur={true}
                                innerRef={formikRef}
                                enableReinitialize={true}
                                validateOnMount={true}
                                onSubmit={() => {
                                }}
                            >
                                {({isSubmitting, values, isValid, setFieldValue, validateForm, resetForm}) => {
                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                    useEffect(() => {
                                        validateForm();
                                    }, [validateForm, values]);
                                    return (
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Field name={'userId'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikSelectDropdownComponent
                                                                    label={'User'}
                                                                    options={CommonService.getFilteredUsersDropdownList(userList, userListDropdown)}
                                                                    placeholder={'Select User'}
                                                                    // valueKey={'code'}
                                                                    valueKey={'id'}
                                                                    // required={true}
                                                                    getOptionLabel={(option) => (`${option.firstName} ${option.lastName}`) || ''}
                                                                    formikField={field}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className="redirect-new-link-wrapper">
                                                        <div>Didn't find user?</div>
                                                        <LinkComponent className={"redirect-link"}
                                                                       onClick={handleRedirectUserModule}>Create
                                                            User</LinkComponent>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <ButtonComponent
                                                        className="mrg-left-20 mrg-top-5"
                                                        disabled={!isValid || isSubmitting || values.userId === ''}
                                                        color={"secondary"}
                                                        variant={"outlined"}
                                                        fullWidth={false}
                                                        size={'large'}
                                                        // isLoading={isGetPhysicianDetailsLoading}
                                                        handleClick={() => {
                                                            // getNpiDetails(values.userId, resetForm)
                                                            locationId && handleAddUser(values.userId, locationId)
                                                        }}>
                                                        Assign User
                                                    </ButtonComponent>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )
                                }
                                }
                            </Formik>
                            <div className={'form-sub-title mrg-top-20 mrg-bottom-20'}>Added Users</div>
                            {!userList?.length ?
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <FeedbackComponent>
                                            No user have been added.
                                        </FeedbackComponent>
                                    </Grid>
                                </Grid> :
                                <>
                                    {userList?.map((locationUser: any, index: any) => {
                                            return (
                                                <div key={index} className="accordion-layout mrg-bottom-20">
                                                    <AccordionComponent
                                                        isExpanded={userList[index]?.isLocationUserExpand}
                                                        title={`${CommonService.capitalizeFirstLetter(locationUser.firstName)} ${CommonService.capitalizeFirstLetter(locationUser.middleName)} ${CommonService.capitalizeFirstLetter(locationUser.lastName)}`}
                                                        subTitle={`(User ID: ${locationUser?.id} | ${userList[index]?.roleObj?.title || ""})`}
                                                        actions={
                                                            userList[index]?.roleObj?.title === "Facility Admin" ?
                                                                <></> :
                                                                <ButtonComponent
                                                                    startIcon={<RemoveCircleIcon/>}
                                                                    variant={"outlined"}
                                                                    fullWidth={false}
                                                                    size={'small'}
                                                                    type={'button'}
                                                                    color={"primary"}
                                                                    handleClick={
                                                                        () => {
                                                                            handleRemoveUser(locationUser)
                                                                        }
                                                                    }

                                                                >
                                                                    Remove
                                                                </ButtonComponent>}
                                                    >
                                                        <div className="locationUser-details-section">
                                                            <UserDetailsComponent user={locationUser}/>
                                                        </div>
                                                    </AccordionComponent>
                                                </div>
                                            )
                                        }
                                    )}
                                </>
                            }
                        </>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            // disabled={formikRef?.current?.isSubmitting}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            color={"primary"}
                            type="button"
                            variant={"contained"}
                            // disabled={formikRef?.current?.isSubmitting}
                            fullWidth={true}
                            handleClick={onHandleNext}
                        >
                            Next
                        </ButtonComponent>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default LocationUserDetailsAddComponent;
